<template>
  <div class="app-container">
    <CrudTable entity="TransportOrder" :allow-create="false" :columns="columns" :generate-summary="generateSummary" />
  </div>
</template>

<script>
import CrudTable from '@/components/crud/CrudTable';

const Labels = {
  Deliver: 'orderLine.deliver',
  PickUp: 'orderLine.pickUp',
  Yes: 'common.yes',
  No: 'common.no',
  Urgent: 'orderLine.urgent'
};

export default {
  components: {
    CrudTable
  },
  data() {
    return {
      columns: [
        {
          field: 'shipmentAt',
          label: 'transportOrder.shipmentAt',
          width: '150px',
          type: 'dateTime',
          filter: { type: 'date' }
        },
        {
          field: 'exportedAt',
          label: 'transportOrder.exportedAt',
          width: '170px',
          type: 'dateTime',
          filter: { type: 'date' }
        },
        {
          field: 'exportedTo',
          label: 'transportOrder.exportedTo',
          width: '45px',
          filterable: false,
          sortable: false
        },
        {
          field: 'workshopNames',
          label: 'transportOrder.workshops',
          sortable: false,
          filter: {
            type: 'select',
            options: this.$store.getters.workshops,
            valueField: 'id',
            labelField: 'name',
            filterName: 'workshopID'
          }
        },
        {
          field: 'truckIdentifier',
          label: 'transportOrder.truckIdentifier',
          filter: {
            type: 'select',
            options: this.trucks,
            valueField: 'name',
            labelField: 'name'
          }
        },
        {
          field: 'domainOrderNumberPrefix',
          label: 'transportOrder.domainOrderNumberPrefix',
          width: '80px',
          filter: {
            type: 'select',
            options: this.$store.getters.domains,
            valueField: 'id',
            labelField: 'orderNumberPrefix',
            filterName: 'domainID'
          }
        },
        {
          field: 'shipToCountryCode',
          label: 'transportOrder.countryCode',
          width: '80px',
          filter: {
            type: 'select',
            options: this.countries,
            valueField: 'code',
            labelField: 'code'
          }
        },
        {
          field: 'deliverAtHomeYN',
          label: 'orderLine.delivery',
          formatter: this.formatDeliverAtHomeYN,
          width: '90px',
          filter: {
            type: 'select',
            options: [
              { value: true, label: this.$t(Labels.Deliver) },
              { value: false, label: this.$t(Labels.PickUp) }
            ],
            valueField: 'value',
            labelField: 'label'
          }
        },
        {
          field: 'shipmentListTypeName',
          label: 'transportOrder.shipmentListTypeName',
          width: '140'
        },
        {
          field: 'reference',
          label: 'transportOrder.reference',
          width: '500px',
          filterable: false,
          sortable: false
        }
      ]
    };
  },
  computed: {
    trucks() {
      return this.$store.getters['truck/loadedItems'];
    },
    countries() {
      return this.$store.getters['country/loadedItems'];
    }
  },
  watch: {
    trucks(trucks) {
      this.getColumn('truckIdentifier').filter.options = trucks;
    },
    countries(countries) {
      this.getColumn('shipToCountryCode').filter.options = countries;
    }
  },
  created() {
    this.$store.dispatch('truck/getItems');
    this.$store.dispatch('country/getItems');
  },
  methods: {
    getColumn(fieldName) {
      return this.columns.find(c => c.field === fieldName);
    },
    generateSummary({ referenceNumber }) {
      return `${referenceNumber}`;
    },
    formatDeliverAtHomeYN(row, column, cellValue) {
      return cellValue ? this.$t(Labels.Deliver) : this.$t(Labels.PickUp);
    }
  }
};
</script>
